(function () {
  var globalKey = 'GeneralProductComparisonController';

  function normalizeValue(valueElement) {
    if (!valueElement) return '';

    return valueElement.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase();
  }

  function initialize(root) {
    if (!root || root.dataset.gpcInitialized === 'true') return;

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-gpc-field-row]'));
    var differenceToggle = root.querySelector('[data-gpc-difference-toggle]');
    var detailsControl = root.querySelector('[data-gpc-details-control]');
    var detailsToggle = root.querySelector('[data-gpc-details-toggle]');
    var detailsLabel = root.querySelector('[data-gpc-details-label]');
    var initialVisibleRows = parseInt(root.dataset.initialVisibleRows, 10) || 5;
    var expanded = false;

    function rowsAreEqual(row) {
      var product1Value = row.querySelector('[data-gpc-value="1"]');
      var product2Value = row.querySelector('[data-gpc-value="2"]');

      return normalizeValue(product1Value) === normalizeValue(product2Value);
    }

    function render() {
      var onlyDifferences = differenceToggle && differenceToggle.checked;
      var visibleRows = rows.filter(function (row) {
        return !onlyDifferences || !rowsAreEqual(row);
      });

      rows.forEach(function (row) {
        row.hidden = true;
      });

      visibleRows.forEach(function (row, index) {
        row.hidden = !expanded && index >= initialVisibleRows;
      });

      var canExpand = visibleRows.length > initialVisibleRows;

      if (detailsControl) {
        detailsControl.hidden = !canExpand;
      }

      if (detailsToggle && detailsLabel) {
        detailsToggle.setAttribute('aria-expanded', String(canExpand && expanded));
        detailsLabel.textContent = expanded
          ? detailsToggle.dataset.hideLabel
          : detailsToggle.dataset.showLabel;
      }
    }

    if (differenceToggle) {
      differenceToggle.addEventListener('change', function () {
        expanded = false;
        render();
      });
    }

    if (detailsToggle) {
      detailsToggle.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }

    root.gpcRevealBlock = function (blockElement) {
      if (!blockElement || !root.contains(blockElement)) return;

      if (differenceToggle) differenceToggle.checked = false;
      expanded = true;
      render();
    };

    root.dataset.gpcInitialized = 'true';
    render();
  }

  function initializeAll(scope) {
    var currentScope = scope || document;

    if (currentScope.matches && currentScope.matches('[data-general-product-comparison]')) {
      initialize(currentScope);
    }

    currentScope.querySelectorAll('[data-general-product-comparison]').forEach(initialize);
  }

  if (!window[globalKey]) {
    window[globalKey] = {
      initializeAll: initializeAll
    };

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('[data-general-product-comparison]');
      if (root && typeof root.gpcRevealBlock === 'function') {
        root.gpcRevealBlock(event.target);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }
  } else {
    window[globalKey].initializeAll(document);
  }
})();
